






















import { Vue, Component, Prop } from "vue-property-decorator";
import AnxIcon from "../AnxIcon/AnxIcon.vue";

/**
 * This component renders a list based on the items provided
 */
@Component({
  components: {
    AnxIcon
  }
})
export default class AnxList extends Vue {
  /** The name of the icon if one should be set */
  @Prop({ default: null }) icon!: string | null;

  /** The items for the list */
  @Prop({ default: null }) items!: Array<string> | null;
  /** List style type css property */
  @Prop({ default: "initial" }) listStyleType!: string;

  /** No padding on the left side for the anx-list */
  @Prop({ default: null }) noPadding!: boolean | null;

  /** To disable spacing between the lines */
  @Prop({ default: null }) noSpacing!: boolean | null;

  /** The margin top for the AnxList */
  @Prop({ default: "0px" }) marginTop!: string;

  /** The margin bottom for the AnxList */
  @Prop({ default: "0px" }) marginBottom!: string;
}
